import { Component, Label, Node, _decorator } from 'cc';

const { ccclass, property } = _decorator;

@ccclass('BaseTool')
export default class BaseTool extends Component {
    @property
    protected readonly displayName: string = '';

    @property(Node)
    private _view: Node = null;

    protected _displayNameLabel: Label = null;

    @property(Node)
    protected get view(): Node {
        return this._view ?? this.node;
    }
    protected set view(value: Node) {
        if (this._view === value) {
            return;
        }
        this._view = value;
    }

    public toggleDisplay(flag: boolean): void {
        this.view.active = flag;
    }

    public addToRoot(root: Node): void {
        root.addChild(this.node);
    }

    public setupDisplayNameLabel(displayNameLabel: Label): void {
        this._displayNameLabel = displayNameLabel;
        this.updateDisplayName();
    }

    protected updateDisplayName(): void {
        if (this._displayNameLabel) {
            this._displayNameLabel.string = this.displayName;
        }
    }
}
